const FILE_TYPES = {
    IMAGE : "data:image/png;base64,",
    PDF : ""
}

export { FILE_TYPES }